import React, { FC } from 'react'
import { Dictionary } from 'typings/shared'
import * as pageUtils from './__index.utils'
import {
	DossierStatusEnum,
	DossierStatusClassesEnum
} from '@services/constants/dossiers.constant'

type statusBadgeProps = {
	dossierStatus?: string
	pageAssets: Dictionary
}

const StatusBadge: FC<statusBadgeProps> = ({ dossierStatus, pageAssets }) => {
	const statusMap = {
		REJETEE: 'Fermé',
		ANNULEE_REQUERANT: 'Fermé',
		NON_REQUISE: 'Fermé',
		DELAI_ATT_ECHU: 'Fermé',
		EN_ATT_DOC_INFO_COURRIEL: 'En attente de documents/informations',    
		EN_ATT_DOC_INFO: 'En attente de documents/informations',
		EN_ANALYSE: 'En traitement'
	}

	if (dossierStatus && statusMap.hasOwnProperty(dossierStatus)) {
		dossierStatus = statusMap[dossierStatus]
	}

	const getRequestStatus = (dossierStatus) => {
		if (
			dossierStatus === DossierStatusEnum.WAITING_FOR_DOCUMENT ||
			dossierStatus === DossierStatusEnum.WAITING_FOR_PAYMENT ||
			dossierStatus === 'En attente de documents/informations'
		) {
			return DossierStatusClassesEnum.WAITING_FOR_PAYMENT
		}

		if (
			dossierStatus === DossierStatusEnum.ISSUED ||
			dossierStatus === DossierStatusEnum.CANCELED ||
			dossierStatus === DossierStatusEnum.COMPLETED ||
			dossierStatus === DossierStatusEnum.COMPLETED_WITH_RESERVATION ||
			dossierStatus === DossierStatusEnum.CANCELING ||
			dossierStatus === 'Fermé'
		) {
			return DossierStatusClassesEnum.COMPLETED
		}

		if (
			dossierStatus === DossierStatusEnum.PROCESSING ||
			dossierStatus === DossierStatusEnum.WAITING_FOR_DECISION ||
			dossierStatus === DossierStatusEnum.WAITING_FOR_APPROVAL ||
			dossierStatus === DossierStatusEnum.SUSPENDED
		) {
			return DossierStatusClassesEnum.PROCESSING
		}
	}

	return (
		<div className={pageUtils.classes.status}>
			<div
				className={`${pageUtils.classes.tag} ${
					pageUtils.classes[getRequestStatus(dossierStatus) ?? '']
				}`}
			>
				{dossierStatus}
			</div>
		</div>
	)
}

export default StatusBadge
